import React, { createContext, useState, useContext, useEffect } from "react";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const token = localStorage.getItem("token") || localStorage.getItem("access_token");

  // Reset only frontend cart
  const resetLocalCart = () => {
    setCartItems([]);
  };

  // Clear cart when no token (logout/new user)
  useEffect(() => {
    if (!token) {
      setCartItems([]);
    }
  }, [token]);

  // Fetch cart after login
  useEffect(() => {
    const fetchCart = async () => {
      if (!token) return;
      try {
        const res = await fetch("https://hrgf.salepatner.com/api/cart/", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.ok) {
          const data = await res.json();
          const mapped = data.map((item) => ({
            id: item.product.id,
            title: item.product.title,
            price: item.product.price,
            image: `https://hrgf.salepatner.com${item.product.image}`,
            quantity: item.quantity,
          }));
          setCartItems(mapped);
        }
      } catch (err) {
        console.error("Error fetching cart:", err);
      }
    };

    fetchCart();
  }, [token]);

  // Add to cart
  const addToCart = async (product) => {
    const existing = cartItems.find((i) => i.id === product.id);

    let updated;
    if (existing) {
      updated = cartItems.map((i) =>
        i.id === product.id ? { ...i, quantity: i.quantity + 1 } : i
      );
    } else {
      updated = [...cartItems, { ...product, quantity: 1 }];
    }

    setCartItems(updated);

    if (token) {
      await fetch("https://hrgf.salepatner.com/api/cart/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ product_id: product.id, quantity: 1 }),
      });
    }
  };

  // Update quantity
  const updateQuantity = async (id, qty) => {
    setCartItems((prev) =>
      prev.map((i) => (i.id === id ? { ...i, quantity: qty } : i))
    );

    if (token) {
      await fetch("https://hrgf.salepatner.com/api/cart/", {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ product_id: id, quantity: qty }),
      });
    }
  };

  // Remove item
  const removeFromCart = async (id) => {
    setCartItems((prev) => prev.filter((i) => i.id !== id));

    if (token) {
      await fetch("https://hrgf.salepatner.com/api/cart/", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ product_id: id }),
      });
    }
  };

  // Clear backend + local
  const clearCart = async () => {
    setCartItems([]);

    if (token) {
      await fetch("https://hrgf.salepatner.com/api/cart/", {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        resetLocalCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
